<div class="counter">{{count}}</div>
<div class="icon">
    <icon name="favorites_counter"></icon>
</div>